import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class B2bVerificationComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/submit';
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/submit((\/?#?)|(\/?#.*?))$/;
  }
}
